import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const mapStateToProps = ({
  retailerSettings: { branding: { brand_call_to_action: ctaColor } = {} } = {},
}) => ({
  ctaColor,
});

const StyledButton = styled.button`
  border-radius: 4px;
  font-size: inherit;
  font-weight: 700;
  background: transparent;
  border: none;
  outline: none;
  box-shadow: inset 0 0 0 ${(props) => (props.selected ? `2px ${props.ctaColor}` : '1px #cccccc')};
  padding: 0.75rem 1rem;
  margin: 0 0.5rem;
  &:hover {
    ${(props) => (props.selected ? '' : `box-shadow: inset 0 0 0 1px ${props.ctaColor}`)};
  }
  @media (max-width: 660px) {
    display: block;
    width: 100%;
    margin: 0.5rem 0;
  }
`;

const ButtonGroup = ({ ctaColor, options, onClick }) => (
  <div>
    {options.map((option) => (
      <StyledButton
        key={option.id || option.label}
        ctaColor={ctaColor}
        selected={option.selected}
        onClick={() => onClick(option)}
      >
        {option.label}
      </StyledButton>
    ))}
  </div>
);

ButtonGroup.defaultProps = {
  ctaColor: '#000000',
  options: [],
  title: '',
};

ButtonGroup.propTypes = {
  ctaColor: PropTypes.string,
  title: PropTypes.string,
  options: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    selected: PropTypes.bool,
  }),
  onClick: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(ButtonGroup);
